import "./style.css";
import {useTranslation} from "react-i18next";

export default function PxmarketsEmptyData(props) {
    const {title} = props;
    const {t} = useTranslation();

    return (
        <div className={"px-empty-state"}>
            <svg
                className={"px-empty-icon"}
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect x="8" y="10" width="48" height="44" rx="8" strokeWidth="1.5" stroke="currentColor" strokeDasharray="4 3"/>
                <rect x="18" y="22" width="28" height="3" rx="1.5" fill="currentColor" opacity="0.25"/>
                <rect x="18" y="30" width="20" height="3" rx="1.5" fill="currentColor" opacity="0.18"/>
                <rect x="18" y="38" width="24" height="3" rx="1.5" fill="currentColor" opacity="0.12"/>
                <circle cx="18" cy="16" r="2" fill="currentColor" opacity="0.3"/>
            </svg>
            <p className={"px-empty-label"}>{title ? t(title) : t("common.noData")}</p>
        </div>
    );
}
